module.exports = __webpack_public_path__ + "static/media/bus.1baab082.png";